import api from './api.js';

/**
 * Auth service for registering, logging in and out, and getting
 * new access token with refresh request
 */
class Auth {

  /**
     * Constructor
     */
  constructor() {

    // Set up URLs
    this.url_register_free = '/auth/register/free';
    this.url_register_paid = '/auth/register/paid';
    this.url_login = '/auth/login';
    this.url_logout = '/auth/logout';
  }

  /**
     * Register a new user
     * @param {} data 
     * @return {Promise}
     */
  registerFree(data) {
    return api.post(this.url_register_free, data);
  }

  /**
     * Register a new user
     * @param {} data 
     * @return {Promise}
     */
  registerPaid(data) {
    return api.post(this.url_register_paid, data);
  }

  /**
     * Login
     * @param {*} creds 
     * @return {Promise}
     */
  login(creds) {
    return api.post(this.url_login, creds);
  }

  /**
     * Log out
     * @return {Promise}
     */
  logout() {
    return api.post(this.url_logout);
  }
}

export default new Auth;